import React from 'react';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-main">
      <div className="footer-col">
        <div className="footer-logo">
          <span role="img" aria-label="logo" style={{color:'#2563eb',fontWeight:'bold',fontSize:'1.3rem',marginRight:8}}>〰️</span>
          <span style={{fontWeight:'bold',fontSize:'1.1rem'}}>AuditAI</span>
        </div>
        <div className="footer-desc">用科技重新定义审计，让信任更简单</div>
      </div>
      <div className="footer-col">
        <div className="footer-title">快速链接</div>
        <div className="footer-link">解决方案</div>
        <div className="footer-link">产品服务</div>
        <div className="footer-link">关于我们</div>
        <div className="footer-link">新闻资讯</div>
      </div>
      <div className="footer-col">
        <div className="footer-title">联系方式</div>
        <div className="footer-link">电话：400-888-8888</div>
        <div className="footer-link">邮箱：contact@auditai.com</div>
        <div className="footer-link">地址：陕西省西安市碑林区广丰国际大厦</div>
      </div>
      <div className="footer-col">
        <div className="footer-title">关注我们</div>
        <div className="footer-socials">
          <a href="#" aria-label="LinkedIn" className="footer-social-icon">🔗</a>
          <a href="#" aria-label="Twitter" className="footer-social-icon">🐦</a>
        </div>
      </div>
    </div>
    <div className="footer-bottom">© 2024 AuditAI. All rights reserved.</div>
  </footer>
);

export default Footer; 